import { Lot } from './Lot';
export class TypeLotsFNSSimple {

	public lot: Lot[];

	constructor() {
		this.lot = [];
	}
}
